export { default } from './EmbedCode'
